<template>
  <LMap
    :options="{zoomSnap: 0.5}"
    style="height: 100%; width: 100%; z-index: 1"
    ref="map"
    :center="normalizedCenter"
    :zoom="zoom"
  >
    <!-- <LDrawToolbar /> -->
    <LTileLayer
      :url="url"
      :attribution="attribution"
    >
    </LTileLayer>


    <slot/>
  </LMap>
</template>

<script>
import 'leaflet/dist/leaflet.css'
// import { latLng } from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";
// import LDrawToolbar from 'vue2-leaflet-draw-toolbar'
// LMarker, LPopup, LTooltip

export default {
  props: {
    center: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 7
    }
  },
  data: () => ({
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),
  computed: {
    normalizedCenter(){
      return this.center
    },
    map() {
      return this.$refs.map.mapObject
    }
  },
  components: {
    LMap,
    LTileLayer,
    // LDrawToolbar
  },
  mounted(){
    this.$nextTick(() => {
      this.$refs.map.mapObject.on('draw:created', (v) => {
        this.$emit('draw:created', v)
      })
      this.$refs.map.mapObject.on('draw:edited', (v) => {
        this.$emit('draw:edited', v)
      })
      this.$refs.map.mapObject.on('draw:deleted', (v) => {
        this.$emit('draw:deleted', v)
      })
    })
  }
}
</script>

<style>
 .leaflet-control-attribution{
  display: none !important; 
}
</style>